/**
 * created by lei lei on 2020/6/12
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import  NumberArticles from'./NumberArticles'
export default class NumberArticlesComponents extends Component {
    static defaultProps = {}
    static propTypes = {}

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let dataSource=[{
            title:'今日群发',
            num:0,
        },{
            title:'今日图文',
            num:20,
        },{
            title:'今日粉丝',
            num:50,
        }];
        let dataSource2=[{
            title:'今日群发',
            num:0,
        },{
            title:'今日图文',
            num:20,
        },{
            title:'今日粉丝',
            num:50,
        },{
            title:'今日图文',
            num:20,
        },{
            title:'今日图文',
            num:20,
        },{
            title:'今日图文',
            num:20,
        }];
        return (
            <div style={{height:500}}>
                <div style={{width:800}}>
                    <NumberArticles
                        dataSource={dataSource}
                        titleKey={'title'}
                        numKey={'num'}
                        onClickFunction={(data)=>{
                            console.log('点击的数据',data)
                        }}
                    />
                </div>

                <NumberArticles
                    dataSource={dataSource2}
                    titleKey={'title'}
                    numKey={'num'}
                />
            </div>
        )
    }

}